var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs15":"","sm10":"","md10":""}},[_c('v-card',{staticClass:"elevation-1",attrs:{"height":"800px"}},[_c('home-page')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }